export var selectCurrentTabId = function (state) {
    var modalStack = state.modals.modalStack;
    var activeMenu = modalStack[modalStack.length - 1];
    return activeMenu && activeMenu.tabId ? activeMenu.tabId : undefined;
};
export var selectModalTabId = function (state, modalId) {
    var modalStack = state.modals.modalStack;
    var activeMenu = modalStack.find(function (modal) { return modal.modalId === modalId; });
    return activeMenu && activeMenu.tabId ? activeMenu.tabId : undefined;
};
export var selectIsModalOpen = function (state, modalId) {
    var modalStack = state.modals.modalStack;
    return modalStack.some(function (modal) { return modal.modalId === modalId; });
};
export var selectLastModalId = function (state) {
    var modalStack = state.modals.modalStack;
    if (modalStack.length > 0) {
        return modalStack[modalStack.length - 1].modalId;
    }
    return undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectModalTabId.ts
// module id = 37
// module chunks = 3